import { createAsyncThunk } from '@reduxjs/toolkit';

import { IQuiz } from '.';
import { APIDataProvider, TApiResponse, AdminApiPaths } from '../../api';
import { TQuestionDifficulty } from '../QuestionSlice';

export interface IAdminQuizGetAll {
  offset: number;
  limit: number;
  topicId?: string;
  subTopicId?: string;
}
export interface IAdminCreateQuiz {
  topicId: string;
  subTopics: Array<{ id: string; paper: string }>;
  difficulty: TQuestionDifficulty;
  noOfQuestions: number;
  assessment: boolean;
}

export interface IAdminGetQuizForAUser {
  offset: number;
  limit: number;
  userId: string;
}

export interface IAdminPublishQuiz {
  id: string;
  isPublished: boolean;
}

const apiDataProvider = new APIDataProvider();

const adminGetQuizListModule = async (data: IAdminQuizGetAll) => {
  let path = `${AdminApiPaths.quizzes}?topicId=${data.topicId}`;

  if (data.offset) {
    path += `&offset=${data.offset}`;
  }

  if (data.limit) {
    path += `&limit=${data.limit}`;
  }

  if (data.subTopicId) {
    path += `&subTopicId=${data.subTopicId}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<{
      offset: number;
      limit: number;
      totalDocs: number;
      docs: Array<IQuiz>;
    }>
  >(path);

  return response.data;
};

const adminGetQuizForAUserModule = async (data: IAdminGetQuizForAUser) => {
  const path = `${AdminApiPaths.quizzes}/user/${data.userId}?offset=${data.offset}&limit=${data.limit}&userId=${data.userId}`;

  const response = await apiDataProvider.get<
    TApiResponse<{
      offset: number;
      limit: number;
      totalDocs: number;
      docs: Array<IQuiz>;
    }>
  >(path);
  return response.data;
};

export const adminGetQuizList = createAsyncThunk(
  'admin/quizzes/list',
  adminGetQuizListModule
);

export const adminLoadMoreQuizList = createAsyncThunk(
  'admin/quizzes/loadMore',
  adminGetQuizListModule
);

export const adminCreateQuiz = createAsyncThunk(
  'admin/quizzes/create',
  async (data: IAdminCreateQuiz) => {
    const response = await apiDataProvider.post<TApiResponse<IQuiz>>(
      AdminApiPaths.quizzes,
      data
    );
    return response.data;
  }
);

export const adminGetQuizById = createAsyncThunk(
  'admin/quizzes/id',
  async (id: string) => {
    const response = await apiDataProvider.get<TApiResponse<IQuiz>>(
      `${AdminApiPaths.quizzes}/${id}`
    );
    return response.data;
  }
);

export const adminPublishQuiz = createAsyncThunk(
  'admin/quizzes/publish',
  async (data: IAdminPublishQuiz) => {
    const { id, ...apiData } = data;
    const response = await apiDataProvider.put<TApiResponse<IQuiz>>(
      `${AdminApiPaths.quizzes}/publish/${id}`,
      apiData
    );
    return response.data;
  }
);

export const adminGetQuizListForAUser = createAsyncThunk(
  'admin/quizzes/user/list',
  adminGetQuizForAUserModule
);

export const adminLoadMoreQuizListForAUser = createAsyncThunk(
  'admin/quizzes/user/loadMore',
  adminGetQuizForAUserModule
);
